// react components
import * as React from 'react'
import { useState, useEffect, useContext } from 'react'

// react-router components
import { Link } from 'react-router-dom'
import PhoneIcon from '@mui/icons-material/Phone'

// prop-types is a library for typechecking of props.
import PropTypes from 'prop-types'

// mui
import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
  Typography,
} from '@mui/material'

// utilities and extra imports
import { callZapier } from 'utils/zapier/callZapier'
import { IntakeContext } from 'context/IntakeContext'
import brand from 'assets/images/parco-logo.svg'
import ScrollingTextBanner from './scrollingTextBanner'

function DashboardNavbar() {
  const { signOut, intakeState, unassume, assumedUser } =
    useContext(IntakeContext)

  const handleJustCallMe = () => {
    const url = 'https://hooks.zapier.com/hooks/catch/15607509/38ulk8i/'

    callZapier({
      user: intakeState,
      hookUrl: url,
      payload: {
        user: {
          firstName: intakeState?.firstName
            ? intakeState.firstName
            : 'Name Not',
          lastName: intakeState?.lastName
            ? intakeState.lastName
            : 'Yet Submitted',
          phoneNumber: intakeState.phone,
          email: intakeState.email,
        },
      },
      sendNotification: true,
      notificationMessage:
        'A request has been sent to PARCO! Expect a call shortly.',
    })
  }

  const handleCallClick = () => {
    handleJustCallMe()
  }

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: '#fff',
        boxShadow: '0px -8px 10px #141727',
        padding: { xs: '0px', sm: '0px 12px' },
      }}
    >
      {/* <ScrollingTextBanner /> */}
      <Container sx={{ maxWidth: '100% !important' }}>
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          <Link to="/dashboard">
            <Box
              sx={{ paddingTop: '5px', width: { xs: '120px', sm: '140px' } }}
              component="img"
              src={brand}
              alt="PARCO Logo"
            />
          </Link>
          {/* <Typography
            variant="h4"
            fontWeight="bold"
            sx={{
              fontSize: { xs: '1.25rem', md: '1.5rem' },
              padding: '0px 10px',
              display: { xs: 'none', md: 'block' },
            }}
          >
            Create Your PARCO Profile
          </Typography> */}
          <Box
            sx={{
              flexGrow: 0,
              display: 'flex',
              justifyContent: 'flex-end',
              width: { lg: '180px' },
            }}
          >
            <Button
              rel="noreferrer"
              startIcon={<PhoneIcon />}
              onClick={handleJustCallMe}
              sx={{
                display: intakeState?.phone === undefined ? 'none' : 'flex',
                whiteSpace: 'normal',
                backgroundColor: '#FFCA7B',
                letterSpacing: '0.25px',
                color: '#262627',
                borderRadius: '200px',
                padding: '10px',
                fontSize: '18px',
                textTransform: 'capitalize',
                paddingLeft: '20px',
                paddingRight: '20px',
                justifyContent: 'flex-start',
                fontWeight: 600,
                '&:hover, &:active, &:focus, &:focus:not(:hover)': {
                  transform: 'scale(1.0)',
                  backgroundColor: '#e5b56e',
                  color: '#262627',
                },
                '& svg': {
                  fontSize: '24px !important',
                },
              }}
            >
              Just Call Me
            </Button>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
}

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
}

export default DashboardNavbar
